import { UserPermission } from "@/utils/authentication";

type PermissionSource = UserPermission | string[] | undefined | null;

export const normalizePermissions = (
  source: PermissionSource
): UserPermission => {
  if (!source) {
    return {};
  }
  if (!Array.isArray(source)) {
    return source;
  }
  return source.reduce<UserPermission>((acc, item) => {
    if (!item) {
      return acc;
    }
    const segments = item.split(":").filter(Boolean);
    if (!segments.length) {
      return acc;
    }
    const action = segments.pop() || "*";
    const resource = segments.join(":") || action;
    if (!acc[resource]) {
      acc[resource] = [];
    }
    if (!acc[resource].includes(action)) {
      acc[resource].push(action);
    }
    return acc;
  }, {});
};
